module.exports = __webpack_public_path__ + "img/estrada_velha2.dad4a6ad.jpg";